import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import Button from "../../components/Button";
import { emailConfig } from "../../emailjsConfig";  // ✔ RUTA CORRECTA

export default function Formulario() {
  const formRef = useRef(null);
  const [estado, setEstado] = useState({ enviando: false, ok: null, msg: "" });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setEstado({ enviando: true, ok: null, msg: "" });

    try {
      const result = await emailjs.sendForm(
        emailConfig.serviceId,
        emailConfig.templateId,
        formRef.current,
        { publicKey: emailConfig.publicKey }
      );

      if (result.text === "OK") {
        setEstado({ enviando: false, ok: true, msg: "✅ Enviado correctamente" });
        formRef.current.reset();
      } else {
        setEstado({ enviando: false, ok: false, msg: "❌ No se pudo enviar. Intenta de nuevo." });
      }
    } catch (err) {
      setEstado({ enviando: false, ok: false, msg: "❌ Error de red o configuración." });
      console.error(err);
    }
  };

  return (
    <div className="p-4 max-w-xl mx-auto flex flex-col gap-4">
      {/* Encabezado */}
      <div className="flex items-center justify-center">
        <h4 className="font-bold text-center">FORMULARIO</h4>
      </div>

      {/* Formulario */}
      <form ref={formRef} onSubmit={handleSubmit} className="flex flex-col gap-4">
        <input type="text" name="nombre" placeholder="Nombre:" className="border p-2 rounded" required />
        <input type="text" name="apellidos" placeholder="Apellidos:" className="border p-2 rounded" required />
        <input type="email" name="correo" placeholder="Correo electrónico:" className="border p-2 rounded" required />
        <textarea name="pregunta" placeholder="Escribe tu pregunta:" className="border p-2 rounded" rows="4" required />

        {/* Correo destino REAL */}
        <input type="hidden" name="to_email" value="disfagiapp.mail@gmail.com" />

        <Button type="submit" disabled={estado.enviando} className="text-white">
          {estado.enviando ? "Enviando..." : "Enviar"}
        </Button>
      </form>

      {/* Mensajes */}
      {estado.ok === true && (
        <p className="mt-3 text-green-700 text-center">{estado.msg}</p>
      )}
      {estado.ok === false && (
        <p className="mt-3 text-red-700 text-center">{estado.msg}</p>
      )}
    </div>
  );
}